module.exports = __webpack_public_path__ + "static/media/Vectorup.6cfa2df4.svg";